export enum enumInvoiceState {
    Open = 1,
    Paid = 2,
    Expired = 3,
    Concept = 4
};